export default __webpack_public_path__ + "static/media/employees.f64f4cee.svg";